import Vue from 'vue';

export const EventBus = new Vue();

export const Channels = {
  convoClicked: 'convo-clicked',
  snackbarMessage: 'snackbar-message',
};
